module Tapas.ViewModels {    

    export class OrderTemplateViewModel extends Ftw.ViewModels.BaseViewModel {        

        constructor() {
            super();
            this.count(1);
        }          
        public OrderTemplateSelectedList = ko.observable<any>();
        public OrderTemplateNewListName = ko.observable('');        
        public OrderTemplateShowNewList = ko.observable(false);
        public OrderTemplateDataService = new Ftw.Dataservice.OrderTemplateDataservice();
        public OrderTemplateList = ko.observableArray([]);
        public OrderTemplateDialogOpen = ko.observable(false);
        public OrderTemplateQuantity = ko.observable(1);        
        public ShowOrderTemplateDialog = ko.observable(false);
        public OrderTemplateId = ko.observable('');
        public OrderTemplateLineId = ko.observable('');
        public Remove = ko.observable(false);
        public ShowInFavourite = ko.observable(false);
        public count = ko.observable();
        public OrderTemplateRelationCount = ko.observable(0);

        public ToggleOrderTemplateDialog() {
            if (this.ShowOrderTemplateDialog())
            {
                this.ShowOrderTemplateDialog(false);    
                return;            
            }                       
            this.GetOrderTemplates();
            this.ShowOrderTemplateDialog(true);
        }
        public GetOrderTemplates (productId?: string) {
            this.OrderTemplateDataService.GetOrderTemplates(productId || '').then((result ) => {
                this.OrderTemplateList(result);
            })
        }

        public AddProductToOrderTemplate(productId: string, quantity: number) {    
            var selectedObject = this.OrderTemplateSelectedList();
            if (!selectedObject) return;
            this.OrderTemplateDataService.AddProductToOrderTemplate(selectedObject.Key(), productId, quantity || this.OrderTemplateQuantity()).then((result) => {
                this.ShowOrderTemplateDialog(false);
                this.ShowInFavourite(true);
                this.OrderTemplateRelationCount(result.Count());
                
                selectedObject.Value.CurrentProductInTemplate(true);
                selectedObject.Value.Count(selectedObject.Value.Count() + 1);
            });
        }       
       
        public CreateNewOrderTemplateList(productId : string, quantity : number) {
            var name = this.OrderTemplateNewListName();
            if (name !== '') {
                //Create the template
                this.OrderTemplateDataService.CreateNewOrderTemplate(name).then((result) => {
                    var newOrderTemplate = result;                                        
                    //Add the product
                    this.OrderTemplateDataService.AddProductToOrderTemplate(result.Key(), productId, quantity || this.OrderTemplateQuantity()).then((result) => {                        
                        //Put the new ordertemplate in the list
                        newOrderTemplate.Value.Count(1);
                        this.OrderTemplateList.push(newOrderTemplate);
                        //Show it on the button and count up
                        this.ShowInFavourite(true);
                        this.OrderTemplateRelationCount(result.Count());
                        //Set the new list as selected
                        this.OrderTemplateSelectedList(newOrderTemplate);
                        this.ShowOrderTemplateDialog(false); 
                        this.ShowInFavourite(true);
                    });
                });
            }
        }
        public DeleteOrderTemplateLine = () =>
        {
            this.OrderTemplateDataService.RemoveLineFromOrderTemplate(this.OrderTemplateId(), this.OrderTemplateLineId()).then((result) => {
                this.Remove(true);
            });
        }
    }
}